import { render } from "./AnalyticsNotesForeignTrade.vue?vue&type=template&id=5d3bce0c&scoped=true&ts=true"
import script from "./AnalyticsNotesForeignTrade.vue?vue&type=script&lang=ts"
export * from "./AnalyticsNotesForeignTrade.vue?vue&type=script&lang=ts"

import "./AnalyticsNotesForeignTrade.vue?vue&type=style&index=0&id=5d3bce0c&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3bce0c"]])

export default __exports__